import { Component, OnInit, Inject, Output, EventEmitter } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface SectionProperties {
  sectionName: string;
  detailPage: boolean;
  editPage: boolean;
  onnew: boolean;
  onedit: boolean;
  column: number;
  imageSection: false,
  systemSection: true,
  id: string;
}
@Component({
  selector: "app-globalaction-sectiondialog",
  templateUrl: "./globalaction-sectiondialog.component.html",
  styleUrls: ["./globalaction-sectiondialog.component.scss"],
})
export class GlobalactionSectiondialogComponent implements OnInit {
  @Output() sectionPropertiesChanged: EventEmitter<SectionProperties> =
    new EventEmitter<SectionProperties>();

  sectionProperties: SectionProperties = {
    sectionName: "",
    detailPage: false,
    editPage: true,
    onnew: true,
    onedit: true,
    column: 2,
    imageSection: false,
    systemSection: true,
    id: "",
  };

  constructor(
    private dialogRef: MatDialogRef<GlobalactionSectiondialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  private normalizeBoolean(value: any, defaultValue: boolean = true): boolean {
    if (value == null) {
      return defaultValue;
    }

    return value === true || value === "true" || value === 1 || value === "1";
  }

  ngOnInit() {
    console.log(this.data);

    if (this.data && this.data.sectionProperties) {
      this.sectionProperties = {
        ...this.sectionProperties,
        ...this.data.sectionProperties,
        onnew: this.normalizeBoolean(this.data.sectionProperties.onnew),
        onedit: this.normalizeBoolean(this.data.sectionProperties.onedit),
      };
    }
  }

  onSave() {
    this.dialogRef.close(this.sectionProperties);
    this.sectionPropertiesChanged.emit(this.sectionProperties);
    console.log("Result *** ", this.sectionProperties);
  }

  close() {
    this.dialogRef.close();
  }
}
